import { render, staticRenderFns } from "./logoSheild.vue?vue&type=template&id=56c329b0"
import script from "./logoSheild.vue?vue&type=script&lang=js"
export * from "./logoSheild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports